import dayjs from 'dayjs'
import { useState, useEffect } from 'react'

interface WeekDay {
  date: number
  day: string
  active: boolean
}

const useCurrentWeek = (): WeekDay[] => {
  const [week, setWeek] = useState<WeekDay[]>([])

  useEffect(() => {
    setWeek(getCurrentWeek)
  }, [])

  const getCurrentWeek = (): WeekDay[] => {
    const today = dayjs()
    const startOfWeek = today.startOf('week')
    const currentDate = today.date()

    return Array.from({ length: 7 }, (_, i) => {
      const date = startOfWeek.add(i, 'day')
      return {
        date: date.date(),
        day: date.format('ddd'),
        active: date.date() === currentDate,
      }
    })
  }

  return week
}

export default useCurrentWeek
